import { array, object, string } from 'yup'
import { StepSchema } from 'components/Wizards/schemas/Types'
import { safify } from 'components/Wizards/schemas/utils/safify'

export const SelectImages = object({
  selected_images: array().of(string()).default([]).transform(safify),
  featured_selected_images: array()
    .of(
      object({
        url: string().required(),
        alt_text: string().default(''),
      }),
    )
    .default([])
    .transform(safify),
}).meta({
  title: 'Images',
  submitLabel: 'Generate',
}) as StepSchema
